import React from "react";

import Dropdown from '../../CommonUtils/Dropdown'

const MessageA13i = (props) => {
  return <Dropdown {...props} />;
};

export default MessageA13i;
